<template>
<div>
  <h3>The rest of Learn mode is coming soon!</h3>
  <p>It looks like you're completing stuff faster than I can write it...</p>
  <p>Check back at the table of contents below every few days to see if I'm adding stuff as this is under active development!</p>
</div>
</template>

<script>
import LearnUtils from '@/js/LearnUtils.js'

export default LearnUtils.createDefaultLearn(['coming_soon'], 'Coming-Soon')
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Learn/ComingSoon.vue